export enum StatusIdE {
  Undefined = 'Undefined',
  Draft = 'Draft',
  Open = 'Open',
  Closed = 'Closed',
  ReOpened = 'ReOpened',
}

export enum TicketsViewModeE {
  List = 'List',
  Cards = 'Cards',
}

export enum TicketAssigneeE {
  WarrCloud = 'WarrCloud',
}

export enum TicketsRefinementKeysE {
  CurrentPage = 'Paging.CurrentPage',
  CountPerPage = 'Paging.CountPerPage',
  Parameter = 'Sorting.Parameter',
  Order = 'Sorting.Order',
  Status = 'Filter.Status',
  TicketAge = 'Filter.TicketAge',
  RONumber = 'Filter.RONumber',
  SearchTerm = 'Filter.SearchTerm',
  AssigneeId = 'Filter.AssigneeId',
  RoofTopId = 'Filter.RoofTopId',
  AssignedToMe = 'Filter.AssignedToMe',
  PastMonth = 'Filter.PastMonth',
  Past30Days = 'Filter.Past30Days',
  IsArchived = 'Filter.IsArchived',
  Schedule = 'Filter.ClosedROAgeRange',
  Category = 'Filter.TicketCategoryIds',
  SubCategory = 'Filter.TicketSubCategoryIds',
  RequestSubCategoryIds = 'Filter.RequestSubCategoryIds',
  Assignee = 'Filter.AssigneeName',
  AgentRoofTopRole = 'AgentRoofTopRole',
  DMSScheduleAccounts = 'Filter.DMSScheduleAccountIds',
  IsSchedule = 'Filter.IsSchedule',
  ScheduleFileId = 'Filter.ScheduleFileId',
}

export enum StatusFilterValuesE {
  Open = 'Open',
  Closed = 'Closed',
}

export enum AgeFilterValuesE {
  Under24Hours = 'Under24hrs',
  Over24Hours = 'Over24hrs',
}

export enum ParameterSortingValuesE {
  RONumber = 'RONumber',
  LineNumber = 'LineNumber',
  Age = 'Age',
  Status = 'Status',
  Assignee = 'Assignee',
  RequestCategory = 'RequestCategory',
  RequestSubcategory = 'RequestSubcategory',
  Amount = 'Amount',
  IsApprovedByDealer = 'IsApprovedByDealer',
  HasAttachment = 'HasAttachment',
  ClaimStatus = 'ClaimStatus',
  TicketPriority = 'TicketPriority',
  ClaimAge = 'ClaimAge',
  SubCategory = 'SubCategory',
  ClosedROAge = 'ClosedROAge',
  Tech = 'TechNumber',
  Advisor = 'AdvisorNumber',
  Vin = 'Vin',
}

export enum TicketActionTypesE {
  Undefined = 'Undefined',
  StatusChange = 'StatusChange',
  Approve = 'Approve',
  GetApproval = 'GetApproval',
}

export enum ScheduleFilterValuesE {
  Undefined = 'undefined',
  LessThan31Days = '0-30',
  From31To60Days = '31-60',
  From61To90Days = '61-90',
  From91To120Days = '91-120',
  Over120Days = '121+',
}

export enum AssigneeFilterValuesE {
  OEM = 'OEM',
  Dealer = 'Dealer',
  WarrCloud = 'WarrCloud',
}
